<template>
  <v-container class="formulario-wrapper" fluid pa-0>
    <div class="content-container elevation-2">

      <v-toolbar color="#4c6faf" dark flat>
        <v-btn icon @click="fecharFormulario" class="ml-n2 mr-2">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-toolbar-title>Configurações</v-toolbar-title>
      </v-toolbar>
      
      <v-card flat>
        <v-card-text>
          <v-form @submit.prevent="handleFormSubmit">
            
            <v-row>
              <v-col cols="8">
                <v-text-field
                  class="text"
                  v-model="formData.senhaSuporte"
                  label="Senha do Suporte"
                  outlined
                  dense
                  autocomplete="off"
                  
                  autocapitalize="none"   spellcheck="false"      :type="showPassword ? 'text' : 'password'"
                  :append-icon="showPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                  @click:append="showPassword = !showPassword"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-btn rounded dark color="#4c6faf" @click="mostrarEtapaDois">
                  OK <v-icon right>mdi-arrow-right</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            
            <div v-if="etapaDoisVisivel" class="etapa-dois-container">  
              <v-text-field
                v-model="formData.empresa"
                label="Empresa"
                outlined
                dense
                autocomplete="off"
              ></v-text-field>

              <v-textarea
                v-model="formData.linkWebService"
                label="Link Web Service"
                outlined
                dense
                hide-details
                :rules="urlRules"
                background-color="white"
                rows="3"
                auto-grow
              ></v-textarea>

              <v-row class="button-wrapper button-wrapper-etapa2 mt-4" justify="center">
                
                <v-btn rounded dark color="#4c6faf" class="mx-2 mb-2" @click="salvarFormulario">
                  Salvar
                </v-btn>

                <v-btn rounded outlined color="warning" class="mx-2 mb-2" @click="apagarDadosDexie">
                  Apagar Dados
                </v-btn>

                <v-btn rounded outlined color="error" class="mx-2 mb-2" @click="deletarBancoDexie">
                  Deletar Banco
                </v-btn>

              </v-row>
            </div>
          </v-form>
        </v-card-text>
      </v-card>
    </div> 

    <v-dialog v-model="dialogVisivel" max-width="400">
      <v-card>
        <v-card-title class="text-h6 primary white--text">{{ dialogTitulo }}</v-card-title>
        <v-card-text class="pt-2 black--text">
          <p>{{ dialogMensagem }}</p>
          
          <v-text-field
            v-model="senhaConfirmacaoAcao"
            label="Senha de autorização"
            type="password"
            outlined
            dense
            class="mt-4"
            autocomplete="new-password"
            hide-details
          ></v-text-field>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" text @click="fecharDialog">
            Cancelar
          </v-btn>
          <v-btn class="primary white--text" text @click="executarAcaoDialog">
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import db from '@/plugins/dexie';
import SnackbarEvent from '@/events/SnackbarEvent';

export default {
  name: 'ViewConfiguracao',
  
  data() {
    return {
      etapaDoisVisivel: false,
      showPassword: false,
      podeApagarDados: false,
      podeDeletarBanco: false,
      dialogVisivel: false,
      dialogTitulo: '',
      dialogMensagem: '',
      dialogAcaoConfirmacao: null,
      senhaConfirmacaoAcao: '',
      
      formData: {
        senhaSuporte: null,
        empresa: null,
        linkWebService: null,
      },
      urlRules: [
      v => !!v || 'O Link é obrigatório.',
      v => /^(http|https):\/\//.test(v) || 'O link deve começar com http:// ou https://'
      ],
    };
  },
  
  methods: {
    handleFormSubmit() {
      if (this.etapaDoisVisivel) {
        this.salvarFormulario();
      } else {
        this.mostrarEtapaDois();
      }
    },

    async mostrarEtapaDois() {
      const senhaDigitada = this.formData.senhaSuporte 
          ? this.formData.senhaSuporte.trim() 
          : '';

      if (senhaDigitada !== '123456') {
        document.dispatchEvent(new SnackbarEvent({
          message: 'Senha incorreta.',
          color: 'error'
        }));
        return;
      }

      try {
        const settings = await db.parametro.get(1);

        if (settings) {
          this.formData.empresa = settings.empresa;
          this.formData.linkWebService = settings.linkwebservice;
        }
        
        this.etapaDoisVisivel = true;
        if (document.activeElement) document.activeElement.blur(); 

      } catch (error) {
        console.error("Erro ao carregar configurações:", error);
        document.dispatchEvent(new SnackbarEvent({ message: 'Erro ao ler banco de dados', color: 'error' }));
      }
    },

    abrirDialogConfirmacao(titulo, mensagem, acao) {
      this.dialogTitulo = titulo;
      this.dialogMensagem = mensagem;
      this.dialogAcaoConfirmacao = acao;
      this.senhaConfirmacaoAcao = '';
      this.dialogVisivel = true;
    },

    fecharDialog() {
      this.dialogVisivel = false;
      this.senhaConfirmacaoAcao = '';
    },

    async executarAcaoDialog() {
      if (this.senhaConfirmacaoAcao !== 'ol3441') {
        document.dispatchEvent(new SnackbarEvent({
          message: 'Senha de autorização incorreta.',
          color: 'error'
        }));
        return;
      }

      this.dialogVisivel = false;
      this.senhaConfirmacaoAcao = '';

      if (typeof this.dialogAcaoConfirmacao === 'function') {
        await this.dialogAcaoConfirmacao();
      }
    },

    apagarDadosDexie() {
      this.abrirDialogConfirmacao(
        'Apagar Dados Parcialmente',
        'Tem certeza que deseja APAGAR OS DADOS locais? Suas configurações e pedidos salvos NÃO serão afetados.',
        async () => {
          try {
            const tabelasProtegidas = ['parametro', 'pedido', 'pedidoitem', 'empresa', 'vendedor'];
            const tabelasParaLimpar = db.tables.filter(
              table => !tabelasProtegidas.includes(table.name)
            );
            await Promise.all(tabelasParaLimpar.map(table => table.clear()));

            const parametros = await db.parametro.toArray();
            if (parametros.length > 0) {
              const primKey = db.parametro.schema.primKey.name;
              
              await Promise.all(parametros.map(param => {
                return db.parametro.update(param[primKey], {
                  databaixado_vendedor: null,
                  databaixado_planopagamento: null,
                  databaixado_tipopedido: null,
                  databaixado: null,
                  databaixado_produto: null,
                  databaixado_grupo: null,
                  databaixado_sugerido: null,
                  databaixado_forma: null,
                  databaixado_destino: null,
                  databaixado_vendas: null,
                  databaixado_financeiro: null
                });
              }));
            }
            
            document.dispatchEvent(new SnackbarEvent({
              message: 'Dados apagados com sucesso. Próxima sincronização será completa.',
              color: 'success'
            }));

            this.fecharFormulario();

          } catch (error) {
            console.error("Erro ao apagar dados:", error);
            document.dispatchEvent(new SnackbarEvent({
              message: 'Erro ao apagar os dados.',
              color: 'error'
            }));
          }
        }
      );
    },

    deletarBancoDexie() {
      this.abrirDialogConfirmacao(
        'Deletar Banco de Dados',
        'ATENÇÃO: Isso deletará todo o banco de dados local (tabelas e dados). A página será recarregada. Deseja continuar?',
        async () => {
          try {
            await db.delete();
            document.dispatchEvent(new SnackbarEvent({
              message: 'Banco deletado. Recarregando...',
              color: 'success'
            }));

            this.$router.back();

            setTimeout(() => {
              window.location.reload();
            }, 1500);

          } catch (error) {
            console.error("Erro ao deletar banco:", error);
            document.dispatchEvent(new SnackbarEvent({
              message: 'Erro ao deletar o banco.',
              color: 'error'
            }));
          }
        }
      );
    },

    async salvarFormulario() {
      if (!this.formData.linkWebService || this.formData.linkWebService.trim() === '') {
        return;
      }

      let urlBase = this.formData.linkWebService.trim();

      const regexUrl = /^(http|https):\/\//;
  
      if (!regexUrl.test(urlBase)) {
        document.dispatchEvent(new SnackbarEvent({
          message: 'O Link deve começar com http:// ou https://',
          color: 'warning'
        }));
        return;
      }
      if (!urlBase.endsWith('/')) {
        urlBase += '/';
      }
      this.formData.linkWebService = urlBase;

      try {
        await this.sincronizarDadosEmpresa(urlBase);
        await this.sincronizarVendedores(urlBase);

        const configAtual = await db.parametro.get(1) || {};
        const dataAgora = new Date()
        await db.parametro.put({
          ...configAtual,
          id: 1,
          empresa: this.formData.empresa,
          linkwebservice: this.formData.linkWebService,
          dataalteracao: dataAgora,
          databaixado_empresa: dataAgora
        });

        this.fecharFormulario();

      } catch (error) {
        console.error("Erro ao salvar configurações:", error);

        const msg = error.message.includes('fetch') 
          ? 'Erro de conexão com o Link informado.' 
          : 'Erro ao salvar dados.';
        
        document.dispatchEvent(new SnackbarEvent({
          message: msg,
          color: 'error'
        }));
      }
    },

    async fetchWcf(metodo, params = '') {
      if (!this.baseUrl) {
        await this.carregarConfiguracoes();
        if (!this.baseUrl) throw new Error("URL da API não configurada no Banco de Dados.");
      }
      
      const url = `${this.baseUrl}${metodo}?ChaveSistema=m1cr0s3rv${params}`;
      
      const headers = {
        'Content-Type': 'application/json'
      };

      try {
        const registroEmpresa = await db.empresa.limit(1).first();
        
        if (registroEmpresa && registroEmpresa.EMPChaveAppVenda) {
          headers['Authorization'] = registroEmpresa.EMPChaveAppVenda;
        }
      } catch (err) {
        console.warn("Não foi possível recuperar a chave da empresa do banco local:", err);
      }

      try {
        const response = await fetch(url, { 
          signal: this.abortController.signal,
          headers: headers 
        });
        
        if (!response.ok) {
          if (response.status === 404) throw new Error(`Rota não encontrada: ${metodo}`);
          if (response.status === 401) throw new Error(`Acesso Negado (Chave Inválida): ${metodo}`);
          throw new Error(`Erro HTTP: ${response.status}`);
        }
        return await response.json();
      } catch (err) {
        if (err.name === 'AbortError') throw new Error('Cancelado');
        if (err.message.includes('Failed to fetch')) {
            throw new Error(`Sem conexão com ${this.baseUrl}. Verifique o servidor.`);
        }
        throw err;
      }
    },

    async baixarImagemBlob(baseUrl, caminhoImagem) {
      if (!caminhoImagem) return null;
      
      try {
        const urlLimpa = baseUrl.replace(/\/$/, '');
        const caminhoCodificado = encodeURIComponent(caminhoImagem);
        const urlCompleta = `${urlLimpa}/empresa/imagem?caminho=${caminhoCodificado}`;

        const response = await fetch(urlCompleta);
        
        if (!response.ok) {
          console.warn(`Aviso: Não foi possível baixar a imagem. Status: ${response.status}`);
          return null;
        }
        const json = await response.json();
        
        const base64 = json.data ? json.data.imagemBase64 : json.imagemBase64; 

        if (!base64) {
          console.warn("Base64 não encontrado no retorno da API.");
          return null;
        }

        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        
        const extensao = caminhoImagem.split('.').pop().toLowerCase();
        let mimeType = 'image/jpeg';
        if (extensao === 'png') mimeType = 'image/png';

        return new Blob([byteArray], { type: mimeType });

      } catch (error) {
        console.error("Erro ao converter a imagem para Blob:", error);
        return null;
      }
    },

    async sincronizarDadosEmpresa(baseUrl) {
      const config = await db.parametro.get(1);
      const ultimaBaixa = config ? config.databaixado_empresa : null;

      let url = `${baseUrl}empresa/dados?ChaveSistema=m1cr0s3rv`;
      
      if (ultimaBaixa) {
        const dataAux = new Date(ultimaBaixa);
        url += `&DataAlteracao=${dataAux.toISOString()}`;
      }
      
      const response = await fetch(url, {
        headers: { 'Content-Type': 'application/json' }
      });

      if (!response.ok) {
        throw new Error(`Erro ao conectar: ${response.statusText}`);
      }

      const responseText = await response.text();

      if (!responseText) {
        return; 
      }

      const dadosEmpresa = JSON.parse(responseText);
      
      if (dadosEmpresa) {
        const e = Array.isArray(dadosEmpresa) ? dadosEmpresa[0] : dadosEmpresa;
        
        if (e) {
          
          let blobImagemDuplicata = null;
          if (e.CaminhoImagemDuplicata) {
            blobImagemDuplicata = await this.baixarImagemBlob(baseUrl, e.CaminhoImagemDuplicata);
          }
          
          await db.empresa.put({
              idEmpresa: e.ID_Empresa,
              NomeEmpresa: e.NM_Empresa,
              NomeFantasia: e.NomeFantasia,
              Telefone: e.Telefone,
              TipoEmpresa: e.TP_Empresa,
              InscricaoEstadual: e.InscricaoEstadual || e.INSCESTADUAL,
              PedirCodigoProduto: e.PedirCodigoProduto,
              Email: e.Email,
              CEP: e.CEP,
              Cnpj: e.Cnpj,
              CpfCnpjFormatado: e.CPF_CNPJ,
              Endereco: e.Endereco,
              EnderecoCompleto: e.EnderecoCompleto,
              CidadeUF: e.CidadeUF,
              EMPChaveAppVenda: e.EMPChaveAppVenda,
              SenhaSmtpNfe: e.SenhaSmtpNfe,
              HostSmtpNfe: e.HostSmtpNfe,
              vendaprodutozerado: e.vendaprodutozerado,
              confirmavendaprodutozerado: e.confirmavendaprodutozerado !== undefined ? e.confirmavendaprodutozerado : e.confirmavendaprodutozerad,
              confirmavendaprodutozerad: e.confirmavendaprodutozerad !== undefined ? e.confirmavendaprodutozerad : e.confirmavendaprodutozerado,
              DataCargaItensTablet: e.DataCargaItensTablet,
              PortaSmtpNfe: e.PortaSmtpNfe,
              CaminhoImagemDuplicata: blobImagemDuplicata,
              CaminhoImagemDuplicataTexto: e.CaminhoImagemDuplicata, 
              databaixado: new Date() 
          });
        }
      }
    },

    async sincronizarVendedores(baseUrl) {
      const paramsDb = await db.parametro.toArray();
      const configAtual = paramsDb[0];
      
      let ultimaBaixa = configAtual ? configAtual.databaixado_vendedor : null;
      const dataDestaBaixa = new Date()

      let qtdVendedores = 0;

      let chaveAppVenda = '';
      try {
        const registroEmpresa = await db.empresa.limit(1).first();
        if (registroEmpresa && registroEmpresa.EMPChaveAppVenda) {
          chaveAppVenda = registroEmpresa.EMPChaveAppVenda;
        }
      } catch (err) {
        console.warn("Aviso: Não foi possível recuperar a chave da empresa do banco local:", err);
      }

      const ajustarDataParaLocal = (date) => {
        const offset = date.getTimezoneOffset() * 60000;
        return new Date(date.getTime() - offset).toISOString().slice(0, -1);
      };

      let dataSincronizacao = null;

      if (!ultimaBaixa) {
        await db.vendedor.clear();
      } else {
        let dataAux = new Date(ultimaBaixa);
        dataSincronizacao = new Date(dataAux.getTime() - (30 * 60 * 1000));
      }
      
      const ultimoVendedor = await db.vendedor.orderBy('idvendedor').last();
      const ultimoId = ultimoVendedor ? ultimoVendedor.idvendedor : 0;

      let url = `${baseUrl}vendedor/lista?ChaveSistema=m1cr0s3rv&UltimoId=${ultimoId}`;
      if (dataSincronizacao) {
        url += `&DataAlteracao=${ajustarDataParaLocal(dataSincronizacao)}`;
      }

      const headers = { 'Content-Type': 'application/json' };
      if (chaveAppVenda) {
        headers['Authorization'] = chaveAppVenda;
      }

      try {
        const response = await fetch(url, { headers });

        if (!response.ok) {
          throw new Error(`Erro na API de vendedores: ${response.statusText}`);
        }

        const responseText = await response.text();
        
        if (responseText) {
          const dadosVendedores = JSON.parse(responseText);

          if (dadosVendedores && dadosVendedores.length > 0) {
            const vendedoresFormatados = dadosVendedores.map(v => ({
              idvendedor: v.IdVendedor, 
              codigo: v.Codigo, 
              nome: v.NomeVendedor,
              senha: v.Senha,
              cpf: v.CPF,
              valormeta: v.ValorMeta,
              databaixado: dataDestaBaixa
            })).filter(v => v.idvendedor !== null);

            qtdVendedores = vendedoresFormatados.length;
            await db.vendedor.bulkPut(vendedoresFormatados);
          }
        }

        if (configAtual) {
          await db.parametro.put({ 
            ...configAtual,
            id: 1, 
            databaixado_vendedor: dataDestaBaixa 
          });
        }
        
        console.log(`Sincronização concluída: ${qtdVendedores} vendedores processados.`);

      } catch (error) {
        console.error("Erro ao sincronizar vendedores:", error);
        throw error;
      }
    },

    resetarFormularioCompleto() {
      this.formData = {
        senhaSuporte: null,
        empresa: null,
        linkWebService: null,
      };
      this.etapaDoisVisivel = false;
      this.showPassword = false;
      this.podeApagarDados = false;
      this.podeDeletarBanco = false;
    },

    fecharFormulario() {
      this.resetarFormularioCompleto();
      this.$router.back();
    },
  },
};
</script>

<style scoped>
.formulario-wrapper {
  background-color: #f5f5f5;
  padding: 0;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.content-container {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
}

.v-card {
  margin-top: 20px;
  border-radius: 0; 
}

.etapa-dois-container {
  animation: fadeIn 0.5s ease-in-out;
}

.button-wrapper-etapa2 {
  justify-content: center;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>